import {LoDashStatic} from "lodash";
import {IStateService} from "angular-ui-router";
require('./toolbarheader.less');
const _ = <LoDashStatic> require('lodash');

class ToolbarheaderController {
    constructor(private $state: IStateService) {}
    toolbarheaderDefinition;

    goBack(){
        if(this.toolbarheaderDefinition.previousState){
            this.$state.go(this.toolbarheaderDefinition.previousState);
        }
        else{
            window.history.back();
        }
    }
}

class ToolbarheaderOptions implements ng.IComponentOptions {
    bindings: any= {
        toolbarheaderDefinition: '='
    };
    controller: string = 'rkcToolbarheaderController';
    controllerAs:string = "c";
    template: any = require('./toolbarheader.html');
}

rkcApp.controller("rkcToolbarheaderController", ['$state', function  ($state) {
    return new ToolbarheaderController($state);
}]).component("rkcToolbarheader", new ToolbarheaderOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/toolbarheader/toolbarheader.ts
 **/